import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const authStoreSelector = (store: RootState) => store.auth;

export const authStoreLoadingSelector = createSelector(authStoreSelector, (store) => store.loading);

export const authStoreAuthedSelector = createSelector(authStoreSelector, (store) => store.authed);

export const authStoreUserTournamentId = createSelector(authStoreSelector, (store) => store.activeTournamentId);

export const authStoreCheckingSelector = createSelector(authStoreSelector, (store) => store.authChecking);

export const authStoreCheckedSelector = createSelector(authStoreSelector, (store) => store.authChecked);

export const authStoreCodeRequestedSelector = createSelector(authStoreSelector, (store) => store.codeRequested);

export const authStoreErrorsSelector = createSelector(authStoreSelector, (store) => store.error);

export const authStoreUserSelector = createSelector(authStoreSelector, (store) => store.user);

export const selectHasTournaments = createSelector(authStoreSelector, (state) => state.hasTournaments ?? false);
